export const DEFAULT_FAQ_PAGE = 0;
export const DEFAULT_DISPLAY_ORDER = 0;
export const DISPLAY_ORDER_MIN = 0;
export const DISPLAY_ORDER_STEP = 1;
export const FAQ_ANSWER_PREVIEW_LIMIT = 100;

const HTML_TAG_PATTERN = /<[^>]*>/g;
const WHITESPACE_PATTERN = /\s+/g;

// The list view shows a plain-text preview of the rich-text answer - strip
// markup rather than rendering it small and unstyled inside a list row.
export const stripHtml = (html) =>
  (html || "").replace(HTML_TAG_PATTERN, " ").replace(WHITESPACE_PATTERN, " ").trim();

export const truncateFaqAnswer = (html) => {
  const plainText = stripHtml(html);

  if (!plainText) {
    return "-";
  }

  return plainText.length > FAQ_ANSWER_PREVIEW_LIMIT
    ? `${plainText.substring(0, FAQ_ANSWER_PREVIEW_LIMIT)}...`
    : plainText;
};
